// Do not put any dispatcher here.
// Only pure API calls
// The Facades should mimic exactly the corresponding API.

import { useCallback } from 'react';
import { useSweepApi } from '../sweep';

export const useStageMetadataFacade = () => {
  const sweepApi = useSweepApi();

  return {
    get_allStagesStageMetadata: useCallback(
      async (leadingFieldIds: string[], crmOrgId: string, funnelId?: string) => {
        const funnelParam = funnelId ? `&funnelId=${funnelId}` : '';
        const response = await sweepApi.get<StageMetadata[]>(
          `/stages?leadingFieldIds=${leadingFieldIds}&crmOrgId=${crmOrgId}${funnelParam}`,
        );
        return response.data;
      },
      [sweepApi],
    ),
    get_opportunityList: useCallback(
      async (crmOrgId: string) => {
        const response = await sweepApi.get(
          `/webapp/config/opportunity-stage-options?crmOrgId=${crmOrgId}`,
        );
        return response.data;
      },
      [sweepApi],
    ),
  };
};
